import * as React from "react";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
import { useTranslation, useCategories } from "@elevio/kb-kit/lib/hooks";
import * as Search from "@elevio/kb-kit/lib/components/search";
import * as Categories from "@elevio/kb-kit/lib/components/categories";
import { getAssetURL } from "@elevio/kb-kit/lib/utils/globals";
import PageLayout from "../components/layouts/Page";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { MainSection, GridContainer, GridItem, } from "../components/layouts/Main";
import ArticleList from "../components/ArticleList";
import Breadcrumb from "../components/PageBreadcrumbs";
import { fetchAgencyFlags } from "../requests/agency-flags";
import { privateSubmissionUrl } from "../utils/privateSubmissionUrl";
export const herrimanLogoUrl = `${window.assetsLocation}/images/herriman-logo.svg`;
export const herrimanBannerUrl = `${window.assetsLocation}/images/herriman-banner.jpeg`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const accessHerrimanLogoUrl = `${window.assetsLocation}/images/herriman-logo-dark.png`;
export const getHeader = () => {
    const { t } = useTranslation();
    return (<Header hideSearch breadcrumbs={<div className="breadcrumbs-header-wrapper">
          <Breadcrumb className="breadcrumbs-header"/>
        </div>}>
      <label htmlFor="search-input" aria-label={t("home.welcome", "How can we help?")}>
        <h1 className="header-text">
          <Trans i18nKey="home.welcome">
            How can we help?
          </Trans>
        </h1>
      </label>
      <Search.Input placeholder={t("search.placeholder", "Please type keywords")} data-testid="search-input" className="hero-search search-bar" id="search-input"/>
    </Header>);
};
const HomePage = () => {
    useCategories();
    const [showViewAllRequests, setShowViewAllRequests] = React.useState(false);
    React.useEffect(() => {
        const AGENCY_ID = 171;
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const openPrivateSubmission = (path) => {
        const url = privateSubmissionUrl(path);
        if (!url) {
            return;
        }
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
            newWindow.opener = null;
        }
    };
    const handleSubmitRequest = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("create");
    };
    const handleViewMyRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("listing");
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("public-map");
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <MainSection className="page-text-color">
        {/* <div className="herriman-logo-wrapper">
          <img className="herriman-logo" src={`${accessHerrimanLogoUrl}`} alt="Herriman"/>
        </div> */}
        <section className="button-container button-container--three">
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleSubmitRequest}>
              <img src={getAssetURL("images/request.svg")} alt="request icon" aria-hidden/>
              Submit a Request
            </button>
          </div>
          <div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleViewMyRequests}>
              <img src={getAssetURL("images/inbox.svg")} alt="inbox icon" aria-hidden/>
              View My Requests
            </button>
          </div>
          {showViewAllRequests ? (<div className="button-wrapper">
              <button type="button" className="cta-request" onClick={handleViewAllRequests}>
                <img src={getAssetURL("images/map.svg")} alt="map icon" aria-hidden/>
                View All Requests
              </button>
            </div>) : null}
        </section>
        <GridContainer>
          <Categories.Loop>
            <GridItem>
              <ArticleList />
            </GridItem>
          </Categories.Loop>
        </GridContainer>
        {/* Code to show subcategories and there artice listing. Maybe required in the future. */}
        {/* <GridContainer>
          {categories.map(category => (
            <Categories.Loop parentCategoryId={category && category.id}>
              <GridItem>
                <ArticleList />
              </GridItem>
            </Categories.Loop>
          ))}
        </GridContainer> */}
      </MainSection>
    </PageLayout>);
};
export default HomePage;
